import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getElementName } from "qpr-base/tplutils/utils";
import React from "react";
import FormikSelect from "./../form/FormikSelect";
import useFormStyles from "./themes";

type Props = {
  GovernmentEntities: any;
  selectedGE: any;
  setSelectedGE: any;
  setFieldValue: (fieldName: string, value: string) => void;
  disabled?: boolean;
  GEOwnerSelectionDisabled?: boolean;
  isProject?: boolean;
};

const KPIOwnershipForm: any = ({
  GovernmentEntities,
  selectedGE,
  setSelectedGE,
  isProject,
  setFieldValue,
  ...props
}: Props) => {
  const classes = useFormStyles();
  const ctx = useAppContext();

  const topElementOptions = GovernmentEntities.map((e: any) => {
    return { title: getElementName(e, ctx.language), value: e.id };
  });

  const handleFieldChange = (value: string) => {
    setFieldValue("location.topelementid", value);
    setFieldValue("parentelementid", value);
    setFieldValue("location.themesymbol", "");
    setFieldValue("location.prioritysymbol", "");
    setSelectedGE(value);
  };

  return (
    <>
      <h1 className={classes.formTitle}>
        {isProject ? t("initiatives.Project Location") : t("kpis.KPI Location")}
      </h1>
      <div className={classes.flexRow}>
        <FormikSelect
          placeholder="Select KPI GE Owner"
          name="location.topelementid"
          label={t("configtypes.Scorecard")}
          options={topElementOptions}
          disabled={
            props.GEOwnerSelectionDisabled === true || props.disabled === true
          }
          handleFieldChange={handleFieldChange}
        />
      </div>
    </>
  );
};
export default KPIOwnershipForm;
